import { 
    Card, 
    CardBody, 
    CardButtons, 
    CardGrid, 
    CardGridAmount, 
    CardGridItem, 
    CardHeader, 
    CardSubtitle, 
    CardTitle, 
    DetailsButton,
} from 'components';
import { formatDate, getPaymentTypeDescription } from 'functions';
import { PaymentDetail } from 'types';
import styles from './CreditCard.module.scss';
import { useNavigation } from 'hooks';

type Props = {
    payment: PaymentDetail,
}

export default function CreditCard({ payment }: Props) {

    const { navigateToCredit } = useNavigation();

    return (
        <Card className={styles.card}>
            <CardHeader className={styles.header}>
                <div className={styles.division}>
                    <CardTitle>
                        <span>Dot Credit {payment.invoiceId}</span>
                    </CardTitle>
                    <CardSubtitle className={styles.subtitle}>
                        <span><strong>Vendor ID</strong>: {payment.vendorId || 'Not Found'}</span>
                        <span><strong>Date</strong>: &nbsp;{payment.invoiceDate ? formatDate(payment.invoiceDate) : 'Not Found'}</span>
                    </CardSubtitle>
                </div>
            </CardHeader>
            <CardBody>
                <CardGrid className={styles.grid}>
                    <CardGridItem className={styles.gridItem} label="Type" value={getPaymentTypeDescription(payment)} />
                    <CardGridAmount className={styles.gridItem} label="Amount" value={payment.adjustmentAmount} />
                </CardGrid>
                <CardButtons>
                    <DetailsButton onClick={() => navigateToCredit(
                        payment.accountId as string,
                        payment.vendorId as string,
                        payment.invoiceId as string,
                        payment.voucherId,
                        payment.adjustmentIdentityKey
                    )} />
                </CardButtons>
            </CardBody>
        </Card>
    )
}
